<template>
  <div>
    <Card>
      <Table
        style="margin-top: 20px;"
        border
        :loading="loading"
        :columns="columns"
        :data="orders"
        :changePage="changePage"
        @on-row-click="onRowClick"
      ></Table>
    </Card>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapGetters, mapActions, mapMutations } from 'vuex'
import { booleanChinese, podStatus, paymentChinese } from '@/libs/table-render'

export default {
  data () {
    return {
      id: this.$route.params.id,
      columns: [
        {
          title: 'ID',
          key: 'id',
          width: 80,
          align: 'center'
        },
        {
          title: i18n.t('pages_balance_transaction_index_177'),
          key: 'created_at_str',
          width: 180,
          align: 'center'
        },
        {
          title: i18n.t('pages_bills_index_197'),
          key: 'code',
          width: 180,
          align: 'center'
        },
        {
          title: i18n.t('pages_bills_index_198'),
          key: 'status',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return paymentChinese(h, params.row.status)
          }
        },
        {
          title: i18n.t('pages_bills_index_199'),
          key: 'payment_method',
          width: 120,
          align: 'center',
          render: (h, params) => {
            return podStatus(h, params.row.payment_method)
          }
        },
        {
          title: i18n.t('pages_bills_index_200'),
          key: 'fresh_customer_username',
          width: 180,
          align: 'center'
        },
        {
          title: i18n.t('pages_bills_index_201'),
          key: 'fresh_customer_mobile',
          width: 180,
          align: 'center'
        },
        {
          title: i18n.t('pages_customers_orders_351'),
          key: 'total',
          width: 100,
          align: 'center'
        },
        {
          title: i18n.t('pages_customers_orders_352'),
          key: 'discount',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return h('div', params.row.discount + '%')
          }
        },
        {
          title: i18n.t('pages_customers_orders_353'),
          key: 'small_discount',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return booleanChinese(h, params.row.small_discount)
          }
        },
        {
          title: i18n.t('pages_customers_orders_354'),
          key: 'discounted_total',
          width: 100,
          align: 'center'
        },
        {
          title: i18n.t('pages_customers_orders_355'),
          key: 'finish_total',
          width: 100,
          align: 'center'
        },
        {
          title: i18n.t('pages_customers_orders_356'),
          key: 'payment_total',
          width: 100,
          align: 'center'
        },
        {
          title: i18n.t('pages_customers_orders_357'),
          key: 'change_amount',
          width: 100,
          align: 'center'
        }
      ]
    }
  },
  created () {
    this.resetQuery()
    this.index({ customer_id: this.id })
  },
  computed: {
    ...mapGetters('order', ['orders', 'meta', 'loading'])
  },
  methods: {
    ...mapActions('order', ['index']),
    ...mapMutations('order', ['changeQuery', 'resetQuery']),
    changePage (page) {
      this.changeQuery({ customer_id: this.id, page })
      this.index()
    },
    onRowClick (params) {
      this.$router.push(`/orders/${params.id}`)
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="less">
.filter-container {
  padding-bottom: 10px;
  .filter-item {
    display: inline-block;
    vertical-align: middle;
    margin-bottom: 10px;
  }
}
</style>
